<template>
  <coop />
</template>

<script>
import { mapGetters } from 'vuex'
import Coop from './Coop'

export default {
  name: 'Dashboard',
  components: { Coop },
  data () {
    return {
      chart: {},
      submitted: false,
      file: File,
      filename: 'Choose File',
      error: [],
      $TIMEOUT: this.$TIMEOUT
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  mounted () {
  },
  ready: function () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    async importExcel () {
      try {
        const formData = new FormData()
        formData.append('file', this.file)
        const { data } = await this.$apiFile.post('/templates/import', formData)
        if (data) {
          data.audit_name = 'test'
          data.version = '1'
          data.description = 'test'
          await this.$api.post('/audits/template', data)
        }
      } catch (e) {
        console.error(e)
      }
    },
    handleResize () {
      this.handler.$emit('dispatch', () => this.$chartist.draw())
    },
    handleSubmit () {
      this.submitted = true
      if (!this.file) {
        this.error.push('Attachment field required.')
        return
      }
      this.importExcel()
    },
    async onFileChange () {
      this.file = this.$refs.file.files[0]
      this.filename = this.file.name
    }

  }
}
</script>

<style scoped>
</style>
